import {
	RENFIELD_RULES_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[RENFIELD_RULES_MODULE_ID]: {
		moduleType: 'static',
		staticPageType: 'renfieldRules',
	},
}
